<main>
    <!-- Banner -->
    <div class="breadcrumb__area breadcrumb__overlay breadcrumb__height p-relative fix"
      data-background="assets/img/breadcurmb/breadcurmb.jpg"
      style="background-image: url(assets/images/breadcurmb/DAD_logo-01.png);">
      <div class="container">
        <div class="row">
          <div class="col-xxl-12">
            <div class="breadcrumb__content z-index text-center">
              <h3 class="breadcrumb__title"> </h3>
              <div class="breadcrumb__list">
                <span><a class="no-underline" routerLink="/index">Home</a></span>
                <!-- <span class="dvdr"><i class="fa fa-angle-right"></i></span>
                <span>MOMents that matter</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Banner End -->

    <!-- <div class="container py-5">
      <div class="row g-3 mb-4">
        <div class="col-md-4">
          <button class="btn btn-outline-primary w-100" (click)="toggleSection('document')">
            Selfie
          </button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-outline-success w-100" (click)="toggleSection('text')">
            Note
          </button>
        </div>
        <div class="col-md-4">
          <button class="btn btn-outline-warning w-100" (click)="redirectAction()">
            Do not want to Participate
          </button>
        </div>
      </div>

      <div *ngIf="openSection === 'document'" class="card p-4 mb-3">
        <h5 class="mb-3">Capture Selfie</h5>
        <button class="btn btn-primary w-100 mb-2" (click)="openCamera()">Open Camera</button>
        <video #videoElement width="100%" height="auto" autoplay></video>
        <canvas #canvasElement style="display:none;"></canvas>
        <button class="btn btn-success w-100 mt-3" (click)="captureImage()">Capture Image</button>
        <img *ngIf="capturedImage" [src]="capturedImage" alt="Captured Image" style="width: 100%; margin-top: 10px;">
        <br />

        <input type="file" (change)="uploadFromFolder($event)" class="form-control" />
        <button class="btn btn-secondary w-100 mt-3" (click)="uploadDocument()">Submit</button>
      </div>

      <div *ngIf="openSection === 'text'" class="card p-4 mb-3">
        <h5 class="mb-3">Note Upload</h5>
        <textarea [(ngModel)]="textInput" class="form-control mb-3" placeholder="Write your text here..."></textarea>
        <button class="btn btn-success w-100" (click)="uploadText()"><i class="fa fa-upload"></i> Submit</button>
      </div>

    </div> -->
      <!-- Redirect  -->
      <!-- <div *ngIf="openSection === 'redirect'" class="card p-4 mb-3">
        <h5 class="mb-3">Voucher Page</h5>
        <button class="btn btn-warning w-100" (click)="redirectAction()">Go to Page</button>
      </div> -->


    <!-- <div class="container py-5">
      <div class="row g-4">
        <div class="d-flex justify-content-center">
          Skip Card
          <div class="col-md-4" style="padding-right: 2%;">
            <div class="card h-100 text-center shadow-sm border headings" (click)="redirectAction()" style="cursor: pointer;">
              <div class="card-body">
                <i class="fa fa-gift fa-3x text-warning mb-2"></i>
                <h5 class="card-title">Claim only primary voucher</h5>
              </div>
            </div>
          </div>

          Selfie Card
          <div class="col-md-4">
            <div class="card h-100 text-center shadow-sm border headings" (click)="toggleSection('document')" style="cursor: pointer;">
              <div class="card-body">
                <i class="fa fa-camera fa-2x text-primary mb-2"></i>
                <h5 class="card-title">Capture Video Message</h5>
              </div>
            </div>
          </div>
        </div>

        Note Card
        <div class="col-md-4">
          <div class="card h-100 text-center shadow-sm border headings" (click)="toggleSection('text')" style="cursor: pointer;">
            <div class="card-body">
              <i class="fa fa-pencil fa-2x text-success mb-2"></i>
              <h5 class="card-title">Write a Note</h5>
            </div>
          </div>
        </div>


      </div>

      Toggle Section: Video
      <div *ngIf="openSection === 'document'" class="card mt-4 p-4 shadow-sm bodies" id="divSelfie">
        <h5 class="text-primary mb-3"><i class="fa fa-camera me-2"></i>Capture Video</h5>

        accept only video
        <input type="file" accept="video/*" (change)="uploadFromFolder($event)" class="form-control mt-2" />

        <button class="btn btn-secondary w-100 mt-3" style="background-color: #ed1d24; color: #fff;" (click)="uploadDocument()" [disabled]="isUploading">
          <ng-container *ngIf="!isUploading"><i class="fa fa-upload me-1"></i> Submit</ng-container>
          <ng-container *ngIf="isUploading">
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Uploading...
          </ng-container>
        </button>
      </div>

      Toggle Section: Selfie
      <div *ngIf="openSection === 'document'" class="card mt-4 p-4 shadow-sm bodies" id="divSelfie">
        <h5 class="text-primary mb-3"><i class="fa fa-camera me-2"></i>Capture Selfie</h5>
        <input type="file" (change)="uploadFromFolder($event)" class="form-control mt-2" />
        <button class="btn btn-secondary w-100 mt-3" style="background-color:  #ed1d24; color: #fff;" (click)="uploadDocument()"><i class="fa fa-upload me-1"></i> Submit</button>
      </div>

      Toggle Section: Note
      <div *ngIf="openSection === 'text'" class="card mt-4 p-4 shadow-sm bodies" id="divNote">
        <h5 class="text-success mb-3"><i class="fa fa-pencil-alt me-2"></i>Note</h5>
        <textarea [(ngModel)]="textInput" class="form-control mb-3" rows="5" placeholder="Write your note here..."></textarea>
        <button class="btn btn-success w-100" style="background-color:  #ed1d24; color: #fff;" (click)="uploadText()"><i class="fa fa-upload me-1"></i> Submit</button>
      </div>
    </div> -->



   <div class="form-container">

    <!-- Address Section -->
    <div *ngIf="showAddressSection" class="section">
      <h3>Address Details</h3>
      <form [formGroup]="addressForm">
        <div class="form-group">
          <label>Address Line 1:</label>
          <input formControlName="address" [readonly]="!isEditing" />
        </div>
        <div class="form-group" *ngIf="isEditing">
          <label>Address Line 2:</label>
          <input formControlName="addressLine2" />
        </div>
        <div class="form-group">
          <label>Pin Code:</label>
          <input formControlName="pin" [readonly]="!isEditing" />
        </div>
        <div class="form-group">
          <label>City:</label>
          <input formControlName="city" [readonly]="!isEditing" />
        </div>
        <div class="form-group">
          <label>State:</label>
          <input formControlName="state" [readonly]="!isEditing" />
        </div>

        <div class="btn-group">
          <button type="button" *ngIf="!isEditing" (click)="edit()">Edit</button>
          <button type="button" *ngIf="isEditing" (click)="update()">Update</button>
          <button type="button" *ngIf="!isEditing" (click)="confirm()">Confirm</button>
        </div>
      </form>
    </div>

    <!-- Navigation Buttons -->
    <div *ngIf="showNavigationButtons" class="btn-group navigation">
      <button (click)="goToPrevious()">Previous</button>
      <button (click)="goToNext()">Next</button>
    </div>

    <!-- Image Upload Section -->
    <div *ngIf="showImageSection" class="section">
      <h3>Upload Image</h3>
      <input type="file" accept="image/*" capture="environment" (change)="onFileSelected($event)">
      <div *ngIf="imageSelected">
        <button (click)="saveImageData(insertId)">Save</button>
      </div>

      <div *ngIf="!imageSelected">
        <p class="error">You are too far from the entered address.</p>
      </div>
    </div>

  </div>






</main>


 <!-- <div *ngIf="openSection === 'redirect'" class="card p-4 mb-3">
              

              Step 1: Mobile Verification
              <div *ngIf="currentStep === 'step1'" class="card p-4 mb-3">
                <h5 class="mb-3">Enter Mobile Number<span class="text-danger">*</span></h5>
                <input type="text" class="form-control" placeholder="Enter Mobile Number" [(ngModel)]="mobileNumber" (keypress)="allowOnlyNumbers($event)" maxlength="10" [readonly]="mobileVerified">
                <button class="btn btn-primary mt-3" (click)="verifyMobile()" [disabled]="mobileVerified">Check</button>
              </div>

              Step 2: Firm Details
              <div *ngIf="currentStep === 'step2'" class="card p-4 mb-3">

                <h5 class="mb-3">Mobile Number :-</h5>

                <label class="mt-2">MobileNo<span class="text-danger">*</span></label>
                <input type="text" class="form-control" [value]="mobileNumber" readonly>
                <br><br>
                <h5 class="mb-3">Enter Firm Details :-</h5>

                <label class="mt-2">Firm Name<span class="text-danger">*</span></label>
                <input type="text" class="form-control mt-2" placeholder="Firm Name" [(ngModel)]="firm_name" [readonly]="firmDetailsValid">

                <label class="mt-2">Referral Name<span class="text-danger">*</span></label>
                <input type="text" class="form-control mt-2" placeholder="Referral Name" [(ngModel)]="refName" [readonly]="firmDetailsValid">

                <label class="mt-2">State<span class="text-danger">*</span></label>
                <input type="text" class="form-control mt-2" placeholder="State" [(ngModel)]="state" [readonly]="firmDetailsValid">

                <label class="mt-2">City<span class="text-danger">*</span></label>
                <input type="text" class="form-control mt-2" placeholder="City" [(ngModel)]="city" [readonly]="firmDetailsValid">


                <button class="btn btn-warning mt-3" (click)="validateFirmDetails()" [disabled]="firmDetailsValid">Validate</button>
                <button class="btn btn-success mt-3" *ngIf="firmDetailsValid" (click)="submitFirmDetails()">Submit</button>
              </div>

            </div> -->